import { create } from 'zustand';

const stored = localStorage.getItem('hesap-theme') || 'light';

export const useTheme = create((set, get) => ({
  theme: stored,
  setTheme: (t) => {
    localStorage.setItem('hesap-theme', t);
    if (t === 'dark') {
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark');
    }
    set({ theme: t });
  },
  toggle: () => {
    const cur = get().theme;
    const next = cur === 'dark' ? 'light' : 'dark';
    get().setTheme(next);
  },
  init: () => {
    const t = get().theme;
    if (t === 'dark') {
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark');
    }
  }
}));
